// Checklists por mes. Cada ítem: { key, descripcion, seccion }
// Secciones: A (Sala máquinas), B (Escotilla), C (Techo cabina), D (Cabina), E (Pozo)

const SECCIONES = {
  A: 'A.- Sala de máquinas',
  B: 'B.- Escotilla',
  C: 'C.- Techo de cabina',
  D: 'D.- Cabina',
  E: 'E.- Pozo',
};

const checklists = {
  // Enero y Julio
  1: [
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'comp_puerta_piso', seccion:'B', descripcion:'Componentes Mecánicos de Puerta de piso' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'cables_traccion', seccion:'B', descripcion:'Estado cables de tracción y limitador' },
    { key:'cable_viajante', seccion:'B', descripcion:'Estado cable viajante y manga de conexiones' },
    { key:'rieles', seccion:'B', descripcion:'Estado de rieles, empalmes, collerines' },
    { key:'imanes', seccion:'B', descripcion:'Estado de imanes y/o pantallas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'poleas_desvio', seccion:'C', descripcion:'Estado de poleas de desvío o conos' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'cajas_cunas', seccion:'E', descripcion:'Limpieza y ajuste de cajas de cuñas' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Febrero y Agosto
  2: [
    { key:'fusibles', seccion:'A', descripcion:'Estado de fusibles en cuadro de control' },
    { key:'interruptores', seccion:'A', descripcion:'Estado de interruptores generales (TDF/TDA)' },
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'polea_cables', seccion:'A', descripcion:'Estado de polea y cables tractores' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'rescate_semi', seccion:'A', descripcion:'Sistema de rescate semiautomático' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'llave_freno', seccion:'A', descripcion:'Existencia Llave de Freno y/o Volante' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'aplome', seccion:'D', descripcion:'Aplome de hojas de puertas' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Marzo
  3: [
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'comp_puerta_piso', seccion:'B', descripcion:'Componentes mecánicos de puerta de piso' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'contacto_elec', seccion:'B', descripcion:'Accionamiento Contacto eléctrico de puerta' },
    { key:'cables_traccion', seccion:'B', descripcion:'Estado cables de tracción y limitador' },
    { key:'cable_viajante', seccion:'B', descripcion:'Estado cable viajante y manga de conexiones' },
    { key:'rieles', seccion:'B', descripcion:'Estado de rieles, empalmes, collerines' },
    { key:'imanes', seccion:'B', descripcion:'Estado de imanes y/o pantallas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'zapatas_cabina', seccion:'C', descripcion:'Zapatas de cabina' },
    { key:'zapatas_contrapeso', seccion:'C', descripcion:'Zapatas de contrapeso' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'poleas_desvio', seccion:'C', descripcion:'Estado de poleas de desvío o conos' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'amortiguadores', seccion:'E', descripcion:'Estado de amortiguadores' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Abril
  4: [
    { key:'fusibles', seccion:'A', descripcion:'Estado de fusibles en cuadro de control' },
    { key:'interruptores', seccion:'A', descripcion:'Estado de interruptores generales (TDF/TDA)' },
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'llave_freno', seccion:'A', descripcion:'Existencia Llave de Freno y/o Volante' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'aplome', seccion:'D', descripcion:'Aplome de hojas de puertas' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'cadena_comp', seccion:'E', descripcion:'Estado de cadena de compensación' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Mayo y Noviembre
  5: [
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'rescate_semi', seccion:'A', descripcion:'Sistema de rescate semiautomático' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'cables_traccion', seccion:'B', descripcion:'Estado cables de tracción y limitador' },
    { key:'cable_viajante', seccion:'B', descripcion:'Estado cable viajante y manga de conexiones' },
    { key:'rieles', seccion:'B', descripcion:'Estado de rieles, empalmes, collerines' },
    { key:'imanes', seccion:'B', descripcion:'Estado de imanes y/o pantallas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'poleas_desvio', seccion:'C', descripcion:'Estado de polea de desvío o conos' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Junio y Diciembre
  6: [
    { key:'fusibles', seccion:'A', descripcion:'Estado de fusibles en cuadro de control' },
    { key:'interruptores', seccion:'A', descripcion:'Estado de interruptores generales (TDF/TDA)' },
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'llave_freno', seccion:'A', descripcion:'Existencia Llave de Freno y/o Volante' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'contacto_elec', seccion:'B', descripcion:'Accionamiento Contacto eléctrico de puerta' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'zapatas_cabina', seccion:'C', descripcion:'Zapatas de cabina' },
    { key:'zapatas_contrapeso', seccion:'C', descripcion:'Zapatas de contrapeso' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'aplome', seccion:'D', descripcion:'Aplome de hojas de puertas' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'amortiguadores', seccion:'E', descripcion:'Estado de amortiguadores' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Septiembre
  9: [
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'comp_puerta_piso', seccion:'B', descripcion:'Componentes mecánicos puerta de piso' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'contacto_elec', seccion:'B', descripcion:'Accionamiento Contacto eléctrico de puerta' },
    { key:'cables_traccion', seccion:'B', descripcion:'Estado cables de tracción y limitador' },
    { key:'cable_viajante', seccion:'B', descripcion:'Estado cable viajante y manga de conexiones' },
    { key:'rieles', seccion:'B', descripcion:'Estado de rieles, empalmes y collerines' },
    { key:'imanes', seccion:'B', descripcion:'Estado de imanes y/o pantallas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'zapatas_cabina', seccion:'C', descripcion:'Zapatas de cabina' },
    { key:'zapatas_contrapeso', seccion:'C', descripcion:'Zapatas de contrapeso' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'poleas_desvio', seccion:'C', descripcion:'Estado de poleas de desvío o conos' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'amortiguadores', seccion:'E', descripcion:'Estado de amortiguadores' },
    { key:'cadena_comp', seccion:'E', descripcion:'Estado de cadena de compensación' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],

  // Octubre
  10: [
    { key:'fusibles', seccion:'A', descripcion:'Estado de fusibles en cuadro de control' },
    { key:'interruptores', seccion:'A', descripcion:'Estado de interruptores generales (TDF/TDA)' },
    { key:'gabinete', seccion:'A', descripcion:'Estado y limpieza de Gabinete Cuadro de Control' },
    { key:'componentes_elec', seccion:'A', descripcion:'Estado de Componentes Eléctricos (Contactores, Relés)' },
    { key:'limitador', seccion:'A', descripcion:'Estado del limitador de velocidad' },
    { key:'enclavamiento_limitador', seccion:'A', descripcion:'Enclavamiento mecánico limitador de velocidad' },
    { key:'maquina', seccion:'A', descripcion:'Estado de la máquina (nivel de aceite, fugas, ruidos)' },
    { key:'frenado', seccion:'A', descripcion:'Estado de Sistema de Frenado de Máquina' },
    { key:'instructivo', seccion:'A', descripcion:'Instructivo de rescate correspondiente al equipo' },
    { key:'nivel_piso', seccion:'A', descripcion:'Marca Nivel de Piso' },
    { key:'llave_freno', seccion:'A', descripcion:'Existencia Llave de Freno y/o Volante' },
    { key:'holgura_corona', seccion:'A', descripcion:'Holgura corona / sin fin' },
    { key:'rotulacion', seccion:'A', descripcion:'Rotulación de Componentes' },
    { key:'sensor_sismo', seccion:'A', descripcion:'Sensor de sismo (si corresponde)' },
    { key:'limpieza_sm', seccion:'A', descripcion:'Limpieza (sin objetos extraños al equipo)' },
    { key:'acceso_sm', seccion:'A', descripcion:'Chequeo de Acceso a Sala de Máquina' },
    { key:'iluminacion_ducto', seccion:'B', descripcion:'Iluminación ducto' },
    { key:'final_prefinal', seccion:'B', descripcion:'Final y Prefinal de recorrido superior e inferior' },
    { key:'limpieza_puertas', seccion:'B', descripcion:'Limpieza de puertas' },
    { key:'botonera_insp', seccion:'C', descripcion:'Revisión de botonera de inspección' },
    { key:'contacto_puerta_cab', seccion:'C', descripcion:'Contacto de cierre de puertas de cabina' },
    { key:'mecanica_puerta', seccion:'C', descripcion:'Mecánica de puerta de cabina' },
    { key:'contacto_cunas', seccion:'C', descripcion:'Contacto de cuñas' },
    { key:'contacto_polea_tensora', seccion:'C', descripcion:'Contacto de polea tensora' },
    { key:'lubricadores', seccion:'C', descripcion:'Lubricadores' },
    { key:'captadores', seccion:'C', descripcion:'Estado de captadores' },
    { key:'operador_puerta', seccion:'C', descripcion:'Estado de Operador de Puerta' },
    { key:'botonera', seccion:'D', descripcion:'Funcionamiento de Botonera' },
    { key:'fotocelula', seccion:'D', descripcion:'Foto células / barrera electrónica' },
    { key:'pesacarga', seccion:'D', descripcion:'Funcionamiento de Pesa Carga' },
    { key:'nivelacion', seccion:'D', descripcion:'Nivelación' },
    { key:'kit_emergencia', seccion:'D', descripcion:'Estado Kit de Emergencia (citofonía, alarma, iluminación)' },
    { key:'aplome', seccion:'D', descripcion:'Aplome de hojas de puertas' },
    { key:'iluminacion_cab', seccion:'D', descripcion:'Iluminación' },
    { key:'id_carga', seccion:'D', descripcion:'Identificación de Carga (N° personas, Kgs)' },
    { key:'registro_mant', seccion:'D', descripcion:'Registro de Mantención mensual' },
    { key:'polea_tensora', seccion:'E', descripcion:'Estado Polea Tensora (Contacto, polea)' },
    { key:'boton_emergencia', seccion:'E', descripcion:'Botón de parada de emergencia' },
    { key:'cajas_cunas', seccion:'E', descripcion:'Limpieza y ajuste de caja de cuñas' },
    { key:'escala', seccion:'E', descripcion:'Estado escala de acceso' },
    { key:'limpieza_pozo', seccion:'E', descripcion:'Limpieza general' },
  ],
};

// Meses que comparten checklist
checklists[7]  = checklists[1];   // Julio = Enero
checklists[8]  = checklists[2];   // Agosto = Febrero
checklists[11] = checklists[5];   // Noviembre = Mayo
checklists[12] = checklists[6];   // Diciembre = Junio

export { SECCIONES };
export default checklists;
